"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useListSurveysLazyQuery = exports.useListSurveysQuery = exports.ListSurveysDocument = void 0;
const client_1 = require("@apollo/client");
const Apollo = __importStar(require("@apollo/client"));
exports.ListSurveysDocument = client_1.gql `
    query ListSurveys($cursorNext: Date, $cursorLast: Date, $limit: Int) {
  listSurveys(cursorNext: $cursorNext, cursorLast: $cursorLast, limit: $limit) {
    data {
      ... on PollFishSurvey {
        id
        duplicate
        plan
        created
        device_id
        cpa
        request_uuid
        timestamp
        tx_id
        signature
        reward_name
        reward_value
        status
        reason
        debug
        updated
      }
      ... on InbrainSurvey {
        id
        duplicate
        plan
        created
        signature
        panelistId
        uniqueSurveyId
        rewardType
        rewardId
        reward
        sessionId
        revenueAmount
        os
      }
      ... on PrecisionSample {
        id
        ug
        reward
        status
        date
        title
        surveyid
        es_id
        gross
        sentDrop
      }
      ... on SenseThreeSixty {
        id
        signature
        length_of_interview
        panelist_id
        status
        survey_id
        project_id
        sentDrop
        created
      }
    }
    total
    cursorNext
    cursorLast
  }
}
    `;
/**
 * __useListSurveysQuery__
 *
 * To run a query within a React component, call `useListSurveysQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSurveysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSurveysQuery({
 *   variables: {
 *      cursorNext: // value for 'cursorNext'
 *      cursorLast: // value for 'cursorLast'
 *      limit: // value for 'limit'
 *   },
 * });
 */
function useListSurveysQuery(baseOptions) {
    return Apollo.useQuery(exports.ListSurveysDocument, baseOptions);
}
exports.useListSurveysQuery = useListSurveysQuery;
function useListSurveysLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(exports.ListSurveysDocument, baseOptions);
}
exports.useListSurveysLazyQuery = useListSurveysLazyQuery;
//# sourceMappingURL=client.generated.js.map